import { Monitor } from "lucide-react";

export function MobileUnsupported() {
  return (
    <main className="flex min-h-dvh items-center justify-center bg-background px-4 py-8 md:hidden">
      <section className="w-full max-w-sm rounded-lg border bg-card p-6 text-card-foreground shadow-sm">
        <div className="mb-5 flex size-11 items-center justify-center rounded-md bg-primary text-primary-foreground">
          <Monitor className="size-5" aria-hidden />
        </div>
        <h1 className="text-balance text-xl font-semibold">Mobile is not supported</h1>
        <p className="mt-3 text-sm leading-6 text-muted-foreground">
          Vadium is currently built for desktop and laptop workflows. Please visit this site from a desktop or laptop browser.
        </p>
      </section>
    </main>
  );
}
